import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { mqMin } from 'utils/responsive';
import ImgPerson01 from 'ui/images/article/thinking_men.png';
import TitleImg from 'ui/images/article/beginner_title.svg';
import ImgPerson02 from 'ui/images/article/person_01.svg';

const DecorativeWrapper = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 5rem 2rem 2rem 2rem;
    background-color: var(--cream);
    border-radius: 15px;

    ${mqMin('SP')} {
        padding: 10rem 2rem 3rem 2rem;
    }

    ${mqMin('NARROW')} {
        padding: 4rem;
        padding-top: 8rem;
    }
`;

const TabShape = styled.div`
    width: auto;
    min-width: 11rem;
    height: 2.3rem;
    background: #fff;
    border: 2px solid #ee793f;
    border-bottom: none;
    border-radius: 20px 20px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    z-index: 2;
    position: relative;
    margin-bottom: -2.5px;
    padding: 0 1.5rem;

    ${mqMin('SP')} {
        min-width: 20rem;
        height: 3.9rem;
        padding: 0 2rem;
    }

    ${mqMin('NARROW')} {
        min-width: 18rem;
        height: 3.6rem;
        padding: 0 2.5rem;
    }
`;

const TabTitle = styled.h2`
    color: #ee793f;
    text-align: center;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 1.2px;
    margin: 0;

    ${mqMin('SP')} {
        font-size: 1.8rem;
    }

    ${mqMin('NARROW')} {
        font-size: 1.7rem;
    }
`;

const MainBox = styled.div`
    position: relative;
    width: 100%;
    min-height: 350px;
    background: #fff;
    border: 2px solid #ee793f;
    border-radius: 20px;
    padding: 30px 20px 60px 20px;
    z-index: 1;

    ${mqMin('SP')} {
        padding: 30px 20px 40px 20px;
    }

    ${mqMin('NARROW')} {
        min-height: 503px;
        padding: 2.4rem 4.4rem;
    }
`;

const LeftIllustration = styled.div`
    width: 4rem;
    margin-bottom: -0.8rem;
    height: auto;
    z-index: 3;
    position: absolute;
    margin-right: 13.5rem;

    ${mqMin('SP')} {
        width: 9.6rem;
        margin-bottom: -2.2rem;
        margin-right: 39rem;
    }

    ${mqMin('NARROW')} {
        width: 8rem;
        margin-right: 34rem;
        margin-bottom: -1.7rem;
    }
`;

const RightIllustration = styled.div`
    width: 5rem;
    margin-bottom: 1rem;
    height: auto;
    z-index: 3;
    position: absolute;
    margin-left: 16rem;

    ${mqMin('SP')} {
        width: 14rem;
        margin-bottom: 1rem;
        margin-left: 49.5rem;
    }

    ${mqMin('NARROW')} {
        width: 10rem;
        margin-bottom: 1rem;
        margin-left: 37rem;
    }
`;

const TopContent = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    position: relative;
`;

const TitleImage = styled.img`
    width: 5rem;
    object-fit: contain;
    position: absolute;
    top: -4rem;

    ${mqMin('SP')} {
        width: 9rem;
        top: -7rem;
    }
`;

interface Props {
    itemText: string;
    onClose: () => void;
    children?: ReactNode;
}

/**
 * M&A初心者向け詳細モーダル
 */
export const MaForBeginnerDetail: React.FC<Props> = ({ itemText, children }) => {
    return (
        <DecorativeWrapper>
            <TopContent>
                <TitleImage src={TitleImg} />
                <LeftIllustration>
                    <img src={ImgPerson01} alt="イラスト" />
                </LeftIllustration>
                <RightIllustration>
                    <img src={ImgPerson02} alt="イラスト" />
                </RightIllustration>
                <TabShape>
                    <TabTitle>{itemText}</TabTitle>
                </TabShape>
            </TopContent>
            <MainBox>{children || <div>{itemText}</div>}</MainBox>
        </DecorativeWrapper>
    );
};
